import { useRef } from "react"
import { LocomotiveScrollProvider } from "react-locomotive-scroll"
import { Outlet, useLocation } from "react-router-dom"

const LocomotiveProvider = () => {
  const location = useLocation()
  const containerRef = useRef(null)
  return (
    <LocomotiveScrollProvider
      options={{
        smooth: true,
      }}
      watch={[]}
      containerRef={containerRef}
      location={location.pathname}
    >
      <div data-scroll-container ref={containerRef}>
        <Outlet />
      </div>
    </LocomotiveScrollProvider>
  )
}

export default LocomotiveProvider
